// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"77fa0ca4","429":"6d1e45d2"}[chunkId] + ".chunk.js";
};